import UserAvatar from "../avatar/avatar";

export function DashoardSvg(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path d="M6.03334 1.66667H4.45001C2.62501 1.66667 1.66667 2.625 1.66667 4.44167V6.025C1.66667 7.84167 2.625 8.80001 4.44167 8.80001H6.025C7.84167 8.80001 8.80001 7.84167 8.80001 6.025V4.44167C8.80834 2.625 7.85 1.66667 6.03334 1.66667Z" />
      <path d="M15.5583 1.66667H13.975C12.1583 1.66667 11.2 2.625 11.2 4.44167V6.025C11.2 7.84167 12.1583 8.80001 13.975 8.80001H15.5583C17.375 8.80001 18.3333 7.84167 18.3333 6.025V4.44167C18.3333 2.625 17.375 1.66667 15.5583 1.66667Z" />
      <path d="M15.5583 11.1917H13.975C12.1583 11.1917 11.2 12.15 11.2 13.9667V15.55C11.2 17.3667 12.1583 18.325 13.975 18.325H15.5583C17.375 18.325 18.3333 17.3667 18.3333 15.55V13.9667C18.3333 12.15 17.375 11.1917 15.5583 11.1917Z" />
      <path d="M6.03334 11.1917H4.45001C2.62501 11.1917 1.66667 12.15 1.66667 13.9667V15.55C1.66667 17.375 2.625 18.3333 4.44167 18.3333H6.025C7.84167 18.3333 8.80001 17.375 8.80001 15.5583V13.975C8.80834 12.15 7.85 11.1917 6.03334 11.1917Z" />
    </svg>
  );
}

export function InboxSvg(props) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path d="M14.1667 2.19461L5.83334 2.19461C3.53334 2.19461 1.66667 4.05294 1.66667 6.34461L1.66667 11.3279V12.1613C1.66667 14.4529 3.53334 16.3113 5.83334 16.3113H7.08334C7.30834 16.3113 7.60834 16.4613 7.75001 16.6446L9.00001 18.3029C9.55001 19.0363 10.45 19.0363 11 18.3029L12.25 16.6446C12.4083 16.4363 12.6583 16.3113 12.9167 16.3113H14.1667C16.4667 16.3113 18.3333 14.4529 18.3333 12.1613V6.34461C18.3333 4.05294 16.4667 2.19461 14.1667 2.19461ZM10.8333 11.9863L5.83334 11.9863C5.49167 11.9863 5.20834 11.7029 5.20834 11.3613C5.20834 11.0196 5.49167 10.7363 5.83334 10.7363L10.8333 10.7363C11.175 10.7363 11.4583 11.0196 11.4583 11.3613C11.4583 11.7029 11.175 11.9863 10.8333 11.9863ZM14.1667 7.81961L5.83334 7.81961C5.49167 7.81961 5.20834 7.53628 5.20834 7.19461C5.20834 6.85294 5.49167 6.56961 5.83334 6.56961L14.1667 6.56961C14.5083 6.56961 14.7917 6.85294 14.7917 7.19461C14.7917 7.53628 14.5083 7.81961 14.1667 7.81961Z" />
    </svg>
  );
}

export function JobTitleSvg() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1251_7187)">
        <path
          d="M18.3336 2.72266H1.66688C1.51954 2.72266 1.37823 2.78119 1.27405 2.88537C1.16986 2.98956 1.11133 3.13087 1.11133 3.27821V4.20599C1.11143 4.3372 1.1375 4.4671 1.18804 4.58819C1.23857 4.70929 1.31257 4.81918 1.40577 4.91155L7.778 11.3782V17.0449L8.88911 17.4671V11.056C8.88953 10.9829 8.87551 10.9104 8.84787 10.8427C8.82022 10.775 8.77948 10.7135 8.728 10.6615L2.22244 4.16155V3.83377H17.778V4.17266L11.2947 10.6615C11.2391 10.7116 11.1943 10.7723 11.1628 10.8401C11.1313 10.9079 11.1138 10.9813 11.1113 11.056V18.3949L12.2224 18.8338V11.3338L18.5947 4.94488C18.6894 4.85017 18.7642 4.7375 18.8148 4.61348C18.8653 4.48945 18.8906 4.35658 18.8891 4.22266V3.27821C18.8891 3.13087 18.8306 2.98956 18.7264 2.88537C18.6222 2.78119 18.4809 2.72266 18.3336 2.72266Z"
          fill="#CCCCCC"
        />
      </g>
      <defs>
        <clipPath id="clip0_1251_7187">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function JobTypeSvg() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.125 11.125V18H1.875V11.125M10 14.25V11.75M12.5 5.5C12.5 5.5 12.5 3 10 3C7.5 3 7.5 5.5 7.5 5.5M1.25 5.5H18.75V10.5C18.75 10.5 15 13 10 13C5 13 1.25 10.5 1.25 10.5V5.5Z"
        stroke="#CCCCCC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function LocationSvg() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 11.75C9.38193 11.75 8.77775 11.5667 8.26384 11.2233C7.74994 10.88 7.3494 10.3919 7.11288 9.82089C6.87635 9.24987 6.81447 8.62154 6.93505 8.01534C7.05563 7.40915 7.35325 6.85233 7.79029 6.41529C8.22733 5.97825 8.78415 5.68063 9.39034 5.56005C9.99654 5.43947 10.6249 5.50135 11.1959 5.73788C11.7669 5.9744 12.255 6.37494 12.5983 6.88884C12.9417 7.40275 13.125 8.00693 13.125 8.625C13.124 9.4535 12.7945 10.2478 12.2086 10.8336C11.6228 11.4195 10.8285 11.749 10 11.75ZM10 6.75C9.62916 6.75 9.26665 6.85997 8.95831 7.066C8.64997 7.27202 8.40964 7.56486 8.26773 7.90747C8.12581 8.25008 8.08868 8.62708 8.16103 8.9908C8.23338 9.35451 8.41195 9.6886 8.67418 9.95083C8.9364 10.2131 9.27049 10.3916 9.63421 10.464C9.99792 10.5363 10.3749 10.4992 10.7175 10.3573C11.0601 10.2154 11.353 9.97504 11.559 9.6667C11.765 9.35835 11.875 8.99584 11.875 8.625C11.8745 8.12787 11.6768 7.65125 11.3253 7.29972C10.9738 6.9482 10.4971 6.7505 10 6.75Z"
        fill="#CCCCCC"
      />
      <path
        d="M10 19.25L4.72751 13.0319C4.65425 12.9385 4.58174 12.8445 4.51001 12.75C3.60937 11.5636 3.12282 10.1145 3.12501 8.625C3.12501 6.80164 3.84934 5.05295 5.13865 3.76364C6.42796 2.47433 8.17664 1.75 10 1.75C11.8234 1.75 13.5721 2.47433 14.8614 3.76364C16.1507 5.05295 16.875 6.80164 16.875 8.625C16.8772 10.1138 16.3909 11.5623 15.4906 12.7481L15.49 12.75C15.49 12.75 15.3025 12.9963 15.2744 13.0294L10 19.25ZM5.50751 11.9969C5.50876 11.9969 5.65376 12.1894 5.68688 12.2306L10 17.3175L14.3188 12.2237C14.3463 12.1894 14.4925 11.9956 14.4931 11.995C15.2289 11.0257 15.6265 9.84189 15.625 8.625C15.625 7.13316 15.0324 5.70242 13.9775 4.64752C12.9226 3.59263 11.4918 3 10 3C8.50816 3 7.07742 3.59263 6.02253 4.64752C4.96764 5.70242 4.37501 7.13316 4.37501 8.625C4.3737 9.84265 4.77112 11.0271 5.50751 11.9969Z"
        fill="#CCCCCC"
      />
    </svg>
  );
}

export function BackSvg() {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.65625 16.4062H29.5312C29.8213 16.4062 30.0995 16.5215 30.3046 16.7266C30.5098 16.9317 30.625 17.2099 30.625 17.5C30.625 17.7901 30.5098 18.0683 30.3046 18.2734C30.0995 18.4785 29.8213 18.5938 29.5312 18.5938H7.65625C7.36617 18.5938 7.08797 18.4785 6.88285 18.2734C6.67773 18.0683 6.5625 17.7901 6.5625 17.5C6.5625 17.2099 6.67773 16.9317 6.88285 16.7266C7.08797 16.5215 7.36617 16.4062 7.65625 16.4062Z"
        fill="#FF6633"
      />
      <path
        d="M8.10906 17.4994L17.1806 26.5688C17.386 26.7742 17.5014 27.0527 17.5014 27.3432C17.5014 27.6336 17.386 27.9122 17.1806 28.1176C16.9753 28.3229 16.6967 28.4383 16.4063 28.4383C16.1158 28.4383 15.8373 28.3229 15.6319 28.1176L5.78813 18.2738C5.68627 18.1722 5.60546 18.0515 5.55032 17.9186C5.49518 17.7857 5.4668 17.6433 5.4668 17.4994C5.4668 17.3556 5.49518 17.2131 5.55032 17.0802C5.60546 16.9474 5.68627 16.8267 5.78813 16.7251L15.6319 6.8813C15.8373 6.67593 16.1158 6.56055 16.4063 6.56055C16.6967 6.56055 16.9753 6.67593 17.1806 6.8813C17.386 7.08668 17.5014 7.36523 17.5014 7.65568C17.5014 7.94613 17.386 8.22468 17.1806 8.43005L8.10906 17.4994Z"
        fill="#FF6633"
      />
    </svg>
  );
}


export function CopySvg() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.75 3H7.1875C7.08437 3 7 3.08437 7 3.1875V4.5C7 4.60312 7.08437 4.6875 7.1875 4.6875H18.8125V20.8125C18.8125 20.9156 18.8969 21 19 21H20.3125C20.4156 21 20.5 20.9156 20.5 20.8125V3.75C20.5 3.33516 20.1648 3 19.75 3ZM16.75 6H4.75C4.33516 6 4 6.33516 4 6.75V19.1883C4 19.3875 4.07969 19.5773 4.22031 19.718L8.28203 23.7797C8.33359 23.8312 8.39219 23.8734 8.45547 23.9086V23.9531H8.55391C8.63594 23.9836 8.72266 24 8.81172 24H16.75C17.1648 24 17.5 23.6648 17.5 23.25V6.75C17.5 6.33516 17.1648 6 16.75 6ZM9.20312 22.5H9.19844L5.6875 18.9891V18.9844H9.20312V22.5Z"
        fill="#5843BD"
      />
    </svg>
  );
}

export function ShareIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z"
        fill="#fff"
      />
    </svg>
  );
}

export function PostJobOptionsSvg(props) {
  return (
    <div className="w-9 h-9 px-[12.05px] py-[7.09px] bg-white rounded-lg shadow border border-indigo-400 border-opacity-30 flex-col justify-center items-center gap-[7.09px] inline-flex">
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4538 1.99151L11.6019 21.891"
          stroke="#5843BD"
          stroke-width="2.12637"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.57812 11.8672L21.4776 12.0153"
          stroke="#5843BD"
          stroke-width="2.12637"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}


export function JobDurationSvg() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 2.99967V1.33301H12.5V2.99967H7.5ZM9.16667 12.1663H10.8333V7.16634H9.16667V12.1663ZM10 18.833C8.97222 18.833 8.00333 18.635 7.09333 18.2388C6.18333 17.8427 5.38833 17.3047 4.70833 16.6247C4.02778 15.9441 3.48945 15.1488 3.09333 14.2388C2.69722 13.3288 2.49945 12.3602 2.5 11.333C2.5 10.3052 2.69806 9.33634 3.09417 8.42634C3.49028 7.51634 4.02833 6.72134 4.70833 6.04134C5.38889 5.36079 6.18417 4.82245 7.09417 4.42634C8.00417 4.03023 8.97278 3.83245 10 3.83301C10.8611 3.83301 11.6875 3.9719 12.4792 4.24967C13.2708 4.52745 14.0139 4.93023 14.7083 5.45801L15.875 4.29134L17.0417 5.45801L15.875 6.62467C16.4028 7.31912 16.8056 8.06217 17.0833 8.85384C17.3611 9.64551 17.5 10.4719 17.5 11.333C17.5 12.3608 17.3019 13.3297 16.9058 14.2397C16.5097 15.1497 15.9717 15.9447 15.2917 16.6247C14.6111 17.3052 13.8158 17.8436 12.9058 18.2397C11.9958 18.6358 11.0272 18.8336 10 18.833ZM10 17.1663C11.6111 17.1663 12.9861 16.5969 14.125 15.458C15.2639 14.3191 15.8333 12.9441 15.8333 11.333C15.8333 9.7219 15.2639 8.3469 14.125 7.20801C12.9861 6.06912 11.6111 5.49967 10 5.49967C8.38889 5.49967 7.01389 6.06912 5.875 7.20801C4.73611 8.3469 4.16667 9.7219 4.16667 11.333C4.16667 12.9441 4.73611 14.3191 5.875 15.458C7.01389 16.5969 8.38889 17.1663 10 17.1663Z" fill="#CCCCCC" />
    </svg>
  );
}

export function CalendarSvg(props) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path d="M13.9583 3.55058V2.25058C13.9583 1.90891 13.675 1.62558 13.3333 1.62558C12.9917 1.62558 12.7083 1.90891 12.7083 2.25058V3.50058L7.29167 3.50058V2.25058C7.29167 1.90891 7.00834 1.62558 6.66667 1.62558C6.325 1.62558 6.04167 1.90891 6.04167 2.25058V3.55058C3.79167 3.75891 2.7 5.10058 2.53334 7.09225C2.51667 7.33391 2.71667 7.53391 2.95 7.53391L17.05 7.53391C17.2917 7.53391 17.4917 7.32558 17.4667 7.09225C17.3 5.10058 16.2083 3.75891 13.9583 3.55058Z" />
      <path d="M16.6667 8.78394L3.33333 8.78394C2.875 8.78394 2.5 9.15894 2.5 9.61727L2.5 14.7506C2.5 17.2506 3.75 18.9173 6.66667 18.9173H13.3333C16.25 18.9173 17.5 17.2506 17.5 14.7506V9.61727C17.5 9.15894 17.125 8.78394 16.6667 8.78394ZM7.675 15.7589C7.63333 15.7923 7.59167 15.8339 7.55 15.8589C7.5 15.8923 7.45 15.9173 7.4 15.9339C7.35 15.9589 7.3 15.9756 7.25 15.9839C7.19167 15.9923 7.14167 16.0006 7.08333 16.0006C6.975 16.0006 6.86667 15.9756 6.76667 15.9339C6.65833 15.8923 6.575 15.8339 6.49167 15.7589C6.34167 15.6006 6.25 15.3839 6.25 15.1673C6.25 14.9506 6.34167 14.7339 6.49167 14.5756C6.575 14.5006 6.65833 14.4423 6.76667 14.4006C6.91667 14.3339 7.08333 14.3173 7.25 14.3506C7.3 14.3589 7.35 14.3756 7.4 14.4006C7.45 14.4173 7.5 14.4423 7.55 14.4756C7.59167 14.5089 7.63333 14.5423 7.675 14.5756C7.825 14.7339 7.91667 14.9506 7.91667 15.1673C7.91667 15.3839 7.825 15.6006 7.675 15.7589ZM7.675 12.8423C7.51667 12.9923 7.3 13.0839 7.08333 13.0839C6.86667 13.0839 6.65 12.9923 6.49167 12.8423C6.34167 12.6839 6.25 12.4673 6.25 12.2506C6.25 12.0339 6.34167 11.8173 6.49167 11.6589C6.725 11.4256 7.09167 11.3506 7.4 11.4839C7.50833 11.5256 7.6 11.5839 7.675 11.6589C7.825 11.8173 7.91667 12.0339 7.91667 12.2506C7.91667 12.4673 7.825 12.6839 7.675 12.8423ZM10.5917 15.7589C10.4333 15.9089 10.2167 16.0006 10 16.0006C9.78333 16.0006 9.56667 15.9089 9.40833 15.7589C9.25833 15.6006 9.16667 15.3839 9.16667 15.1673C9.16667 14.9506 9.25833 14.7339 9.40833 14.5756C9.71667 14.2673 10.2833 14.2673 10.5917 14.5756C10.7417 14.7339 10.8333 14.9506 10.8333 15.1673C10.8333 15.3839 10.7417 15.6006 10.5917 15.7589ZM10.5917 12.8423C10.55 12.8756 10.5083 12.9089 10.4667 12.9423C10.4167 12.9756 10.3667 13.0006 10.3167 13.0173C10.2667 13.0423 10.2167 13.0589 10.1667 13.0673C10.1083 13.0756 10.0583 13.0839 10 13.0839C9.78333 13.0839 9.56667 12.9923 9.40833 12.8423C9.25833 12.6839 9.16667 12.4673 9.16667 12.2506C9.16667 12.0339 9.25833 11.8173 9.40833 11.6589C9.48333 11.5839 9.575 11.5256 9.68333 11.4839C9.99167 11.3506 10.3583 11.4256 10.5917 11.6589C10.7417 11.8173 10.8333 12.0339 10.8333 12.2506C10.8333 12.4673 10.7417 12.6839 10.5917 12.8423ZM13.5083 15.7589C13.35 15.9089 13.1333 16.0006 12.9167 16.0006C12.7 16.0006 12.4833 15.9089 12.325 15.7589C12.175 15.6006 12.0833 15.3839 12.0833 15.1673C12.0833 14.9506 12.175 14.7339 12.325 14.5756C12.6333 14.2673 13.2 14.2673 13.5083 14.5756C13.6583 14.7339 13.75 14.9506 13.75 15.1673C13.75 15.3839 13.6583 15.6006 13.5083 15.7589ZM13.5083 12.8423C13.4667 12.8756 13.425 12.9089 13.3833 12.9423C13.3333 12.9756 13.2833 13.0006 13.2333 13.0173C13.1833 13.0423 13.1333 13.0589 13.0833 13.0673C13.025 13.0756 12.9667 13.0839 12.9167 13.0839C12.7 13.0839 12.4833 12.9923 12.325 12.8423C12.175 12.6839 12.0833 12.4673 12.0833 12.2506C12.0833 12.0339 12.175 11.8173 12.325 11.6589C12.4083 11.5839 12.4917 11.5256 12.6 11.4839C12.75 11.4173 12.9167 11.4006 13.0833 11.4339C13.1333 11.4423 13.1833 11.4589 13.2333 11.4839C13.2833 11.5006 13.3333 11.5256 13.3833 11.5589C13.425 11.5923 13.4667 11.6256 13.5083 11.6589C13.6583 11.8173 13.75 12.0339 13.75 12.2506C13.75 12.4673 13.6583 12.6839 13.5083 12.8423Z" />
    </svg>
  );
}

export function JobPostSvg(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path d="M17.575 5.81667C16.8667 5.03334 15.6833 4.64167 13.9667 4.64167H13.7667V4.60834C13.7667 3.20834 13.7667 1.47501 10.6333 1.47501L9.36667 1.47501C6.23334 1.47501 6.23334 3.21667 6.23334 4.60834V4.65001H6.03334C4.30834 4.65001 3.13334 5.04167 2.42501 5.82501C1.60001 6.74167 1.62501 7.97501 1.70834 8.81667L1.71667 8.87501L1.77813 9.52027C1.79197 9.66563 1.87029 9.79697 1.99255 9.8768C2.19443 10.0086 2.5084 10.2102 2.70001 10.3167C2.81667 10.3917 2.94167 10.4583 3.06667 10.525C4.49167 11.3083 6.05834 11.8333 7.65001 12.0917C7.72501 12.875 8.06667 13.7917 9.89167 13.7917C11.7167 13.7917 12.075 12.8833 12.1333 12.075C13.8333 11.8 15.475 11.2083 16.9583 10.3417C17.0083 10.3167 17.0417 10.2917 17.0833 10.2667C17.4054 10.0847 17.7392 9.86146 18.0452 9.64157C18.155 9.56265 18.2252 9.44025 18.2401 9.30582L18.25 9.21667L18.2917 8.82501C18.3 8.77501 18.3 8.73334 18.3083 8.67501C18.375 7.83334 18.3583 6.68334 17.575 5.81667ZM10.9083 11.525C10.9083 12.4083 10.9083 12.5417 9.88334 12.5417C8.85834 12.5417 8.85834 12.3833 8.85834 11.5333V10.4833H10.9083L10.9083 11.525ZM7.42501 4.64167V4.60834C7.42501 3.19167 7.42501 2.66667 9.36667 2.66667H10.6333C12.575 2.66667 12.575 3.20001 12.575 4.60834V4.65001L7.42501 4.65001V4.64167Z" />
      <path d="M17.2842 11.4975C17.6277 11.335 18.0223 11.6075 17.988 11.986L17.7 15.1583C17.525 16.825 16.8417 18.525 13.175 18.525H6.825C3.15833 18.525 2.475 16.825 2.3 15.1667L2.02695 12.1631C1.99294 11.789 2.37928 11.5172 2.72183 11.6713C3.68039 12.1026 5.31644 12.8077 6.36069 13.0876C6.51991 13.1302 6.64904 13.2447 6.72083 13.3931C7.23357 14.453 8.32416 15.0167 9.89166 15.0167C11.4437 15.0167 12.5477 14.4313 13.0623 13.3683C13.1342 13.2198 13.2633 13.1054 13.4226 13.0625C14.533 12.7632 16.2793 11.973 17.2842 11.4975Z" />
    </svg>
  );
}

export function CandidatesSvg(props) {
  return (
    <svg
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path d="M6.35361 7.61911C8.28578 7.61911 9.85567 6.04923 9.85567 4.11707C9.85567 2.1849 8.28578 0.615021 6.35361 0.615021C4.42145 0.615021 2.85158 2.1849 2.85158 4.11707C2.85158 6.04923 4.42145 7.61911 6.35361 7.61911Z" />
      <path d="M13.1536 13.0905V14.6883C13.1536 15.0691 12.847 15.385 12.4569 15.385H0.696694C0.315835 15.385 0 15.0691 0 14.6883V13.0905C0 10.8518 1.82069 9.03113 4.0594 9.03113H9.09417C9.54934 9.03113 9.98595 9.10544 10.3947 9.25407C10.3947 9.25407 10.3947 9.24478 10.404 9.25407C12.0017 9.79284 13.1536 11.307 13.1536 13.0905Z" />
      <path d="M13.1536 13.0905V14.6883C13.1536 15.0691 12.847 15.385 12.4569 15.385H0.696694C0.315835 15.385 0 15.0691 0 14.6883V13.0905C0 10.8518 1.82069 9.03113 4.0594 9.03113H9.09417C9.54934 9.03113 9.98595 9.10544 10.3947 9.25407C10.3947 9.25407 10.3947 9.24478 10.404 9.25407C12.0017 9.79284 13.1536 11.307 13.1536 13.0905Z" />
      <path d="M18.5787 12.2914V13.6012C18.5787 13.9078 18.3279 14.1586 18.0214 14.1586H14.5472V13.0903C14.5472 12.1521 14.3057 11.2603 13.8877 10.4893C13.7112 10.1735 13.5161 9.87623 13.2932 9.60684C13.1352 9.43035 12.9773 9.25385 12.8101 9.10522H15.3925C15.4947 9.10522 15.5876 9.10522 15.6805 9.1238C15.8013 9.13309 15.922 9.15167 16.0428 9.17953C16.7488 9.32816 17.3619 9.71832 17.817 10.2385C17.8913 10.3221 17.9657 10.415 18.0307 10.5172C18.04 10.5172 18.04 10.5172 18.0307 10.5265C18.2072 10.7866 18.3465 11.0653 18.4394 11.3718C18.4673 11.474 18.4951 11.5762 18.5137 11.6783C18.5602 11.8734 18.5787 12.0778 18.5787 12.2914Z" />
      <path d="M13.3581 7.48887C14.892 7.48887 16.1355 6.24535 16.1355 4.71138C16.1355 3.17742 14.892 1.9339 13.3581 1.9339C11.8241 1.9339 10.5806 3.17742 10.5806 4.71138C10.5806 6.24535 11.8241 7.48887 13.3581 7.48887Z" />
    </svg>
  );
}

export function DetailsSvg(props) {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.4164 4.07964L14.2256 9.31972H14.2173C14.148 9.40807 14.0609 9.47918 13.9621 9.5279C13.8634 9.57662 13.7555 9.60174 13.6464 9.60144C13.4711 9.60115 13.3014 9.53677 13.1665 9.41941C13.0911 9.35378 13.0288 9.2732 12.9832 9.1823C12.9376 9.09139 12.9095 8.99194 12.9007 8.88966C12.8919 8.78738 12.9024 8.68427 12.9317 8.58626C12.961 8.48825 13.0084 8.39726 13.0713 8.31851L17.2663 3.0871C17.3483 2.99935 17.4121 2.89482 17.4538 2.78006C17.4955 2.66529 17.5142 2.54274 17.5086 2.42008C17.503 2.29742 17.4734 2.17728 17.4215 2.06718C17.3696 1.95707 17.2965 1.85937 17.207 1.78017C17.1174 1.70097 17.0132 1.64198 16.9009 1.60688C16.7885 1.57179 16.6705 1.56135 16.5542 1.57621C16.4378 1.59107 16.3256 1.63092 16.2247 1.69326C16.1237 1.7556 16.0361 1.8391 15.9673 1.93853L11.8302 7.23929C11.774 7.33436 11.699 7.41574 11.6102 7.47795C11.5215 7.54016 11.4211 7.58177 11.3158 7.59999C11.2104 7.61821 11.1026 7.61262 10.9995 7.58359C10.8963 7.55456 10.8003 7.50276 10.7179 7.43167C10.6355 7.36058 10.5685 7.27185 10.5215 7.17142C10.4745 7.07099 10.4485 6.96119 10.4453 6.84938C10.4421 6.73757 10.4618 6.62634 10.503 6.52315C10.5442 6.41996 10.606 6.3272 10.6843 6.25109L14.8048 0.94599C14.9978 0.686763 15.2385 0.470745 15.5126 0.310728C15.5417 0.293737 15.5711 0.277414 15.6009 0.261767C15.0983 0.092022 14.5599 0 14 0H5C2.23858 0 0 2.23858 0 5V15C0 17.7614 2.23858 20 5 20H14C16.7614 20 19 17.7614 19 15V5C19 4.48096 18.9209 3.98039 18.7741 3.50969C18.681 3.71573 18.5607 3.90764 18.4164 4.07964ZM12.5335 11.9853C12.6163 15.0322 8.79779 17 6.16249 17C5.77894 17.0019 5.40142 16.9 5.06654 16.7041C4.73167 16.5081 4.4508 16.2249 4.25118 15.8817C4.09272 15.61 4.00613 15.299 4.00031 14.9806C3.9945 14.6622 4.06966 14.3479 4.21809 14.07C4.5412 13.4311 4.80711 12.7623 5.0124 12.072L5.02362 12.0378C5.37522 10.9667 5.70973 9.94773 6.70444 9.09C7.06349 8.77687 7.47819 8.54135 7.92459 8.39705C8.371 8.25274 8.84027 8.20251 9.3053 8.24926C9.77034 8.296 10.2219 8.4388 10.634 8.6694C11.0461 8.89999 11.4105 9.21383 11.7061 9.59278C12.237 10.2665 12.5293 11.1117 12.5335 11.9853ZM7.6932 10.2949C8.05357 9.97686 8.50862 9.80057 8.97982 9.79648L9.0005 9.80949C9.06663 9.80518 9.13295 9.80518 9.19908 9.80949C9.46841 9.83534 9.7301 9.91728 9.96879 10.0505C10.2075 10.1837 10.4184 10.3656 10.5891 10.5853C10.8877 10.984 11.0455 11.4786 11.0359 11.9853C11.0359 14.2174 7.81317 15.431 6.15836 15.431C6.03827 15.4289 5.92041 15.3967 5.81462 15.3371C5.70882 15.2775 5.61817 15.1923 5.55021 15.0886C5.52602 15.0508 5.51311 15.0062 5.51311 14.9607C5.51311 14.9152 5.52602 14.8707 5.55021 14.8329C5.91579 14.112 6.21767 13.3576 6.45209 12.5791L6.45809 12.561C6.78177 11.5865 7.01477 10.8851 7.6932 10.2949Z"
      />
    </svg>
  );
}

export function ResumeSvg(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM16.5496 12.8818C16.6965 12.7349 16.7789 12.5358 16.7789 12.3281C16.7789 12.1216 16.6969 11.9235 16.5509 11.7774C16.4048 11.6314 16.2068 11.5494 16.0002 11.5494H10.0647C9.86763 11.564 9.68341 11.6527 9.54897 11.7975C9.41453 11.9423 9.33982 12.1326 9.33982 12.3302C9.33982 12.5279 9.41453 12.7182 9.54897 12.863C9.68341 13.0078 9.86763 13.0964 10.0647 13.1111H15.9959C16.2036 13.1111 16.4028 13.0286 16.5496 12.8818ZM10.0604 14.5171H13.2618C13.4588 14.5318 13.643 14.6205 13.7775 14.7653C13.9119 14.9101 13.9866 15.1004 13.9866 15.298C13.9866 15.4956 13.9119 15.6859 13.7775 15.8307C13.643 15.9756 13.4588 16.0642 13.2618 16.0789H10.0604C9.86331 16.0642 9.67908 15.9756 9.54464 15.8307C9.4102 15.6859 9.33549 15.4956 9.33549 15.298C9.33549 15.1004 9.4102 14.9101 9.54464 14.7653C9.67908 14.6205 9.86331 14.5318 10.0604 14.5171ZM16.5539 8.79797C16.4071 8.65112 16.2079 8.56862 16.0002 8.56862H10.0647C9.85702 8.56862 9.65785 8.65112 9.511 8.79797C9.36415 8.94481 9.28165 9.14398 9.28165 9.35166C9.28165 9.55934 9.36415 9.75851 9.511 9.90535C9.65785 10.0522 9.85702 10.1347 10.0647 10.1347H16.0002C16.2079 10.1347 16.4071 10.0522 16.5539 9.90535C16.7008 9.75851 16.7833 9.55934 16.7833 9.35166C16.7833 9.14398 16.7008 8.94481 16.5539 8.79797ZM7.47175 10.6591C7.61658 10.5246 7.70522 10.3404 7.7199 10.1434C7.7199 9.52147 7.47286 8.92507 7.03312 8.48533C6.59339 8.0456 5.99698 7.79856 5.3751 7.79856C4.75322 7.79856 4.15681 8.0456 3.71708 8.48533C3.27734 8.92507 3.0303 9.52147 3.0303 10.1434V15.2959C3.0303 15.5035 3.1128 15.7027 3.25965 15.8495C3.4065 15.9964 3.60567 16.0789 3.81334 16.0789C4.02102 16.0789 4.22019 15.9964 4.36704 15.8495C4.51389 15.7027 4.59639 15.5035 4.59639 15.2959V13.5005H5.3751C5.57216 13.4858 5.75639 13.3972 5.89083 13.2523C6.02527 13.1075 6.09998 12.9172 6.09998 12.7196C6.09998 12.522 6.02527 12.3317 5.89083 12.1869C5.75639 12.042 5.57216 11.9534 5.3751 11.9387H4.59639V10.1434C4.61106 9.94629 4.6997 9.76207 4.84453 9.62763C4.98936 9.49319 5.17966 9.41848 5.37726 9.41848C5.57487 9.41848 5.76517 9.49319 5.91 9.62763C6.05482 9.76207 6.14346 9.94629 6.15814 10.1434C6.17282 10.3404 6.26146 10.5246 6.40629 10.6591C6.55111 10.7935 6.74141 10.8682 6.93902 10.8682C7.13663 10.8682 7.32693 10.7935 7.47175 10.6591ZM16.516 4.49057C16.3815 4.34574 16.1973 4.2571 16.0002 4.24242H3.80037C3.6033 4.2571 3.41908 4.34574 3.28464 4.49057C3.1502 4.63539 3.07549 4.8257 3.07549 5.0233C3.07549 5.22091 3.1502 5.41121 3.28464 5.55604C3.41908 5.70086 3.6033 5.7895 3.80037 5.80418H16.0002C16.1973 5.7895 16.3815 5.70086 16.516 5.55604C16.6504 5.41121 16.7251 5.22091 16.7251 5.0233C16.7251 4.8257 16.6504 4.63539 16.516 4.49057Z"
      />
    </svg>
  );
}

export function EmployeesSvg(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path d="M5.98999 0.039978H3.82999C1.71999 0.039978 0 1.75998 0 3.86998V5.93998C0 6.34998 0.34 6.68998 0.75 6.68998C1.16 6.68998 1.5 6.34998 1.5 5.93998V3.86998C1.5 2.57998 2.54999 1.53998 3.82999 1.53998H5.98999C6.39999 1.53998 6.73999 1.19998 6.73999 0.789978C6.73999 0.379978 6.40999 0.039978 5.98999 0.039978Z" />
      <path d="M16.02 0.039978H13.86C13.45 0.039978 13.11 0.379978 13.11 0.789978C13.11 1.19998 13.45 1.53998 13.86 1.53998H16.02C17.31 1.53998 18.35 2.58998 18.35 3.86998V5.93998C18.35 6.34998 18.69 6.68998 19.1 6.68998C19.51 6.68998 19.85 6.34998 19.85 5.93998V3.86998C19.86 1.75998 18.14 0.039978 16.02 0.039978Z" />
      <path d="M5.98999 18.46H3.82999C2.53999 18.46 1.5 17.41 1.5 16.13V14.06C1.5 13.65 1.16 13.31 0.75 13.31C0.34 13.31 0 13.65 0 14.06V16.13C0 18.24 1.71999 19.96 3.82999 19.96H5.98999C6.39999 19.96 6.73999 19.63 6.73999 19.21C6.73999 18.8 6.40999 18.46 5.98999 18.46Z" />
      <path
        d="M19.11 13.31C18.7 13.31 18.36 13.65 18.36 14.06V16.13C18.36 17.42 17.31 18.46 16.03 18.46H13.87C13.46 18.46 13.12 18.8 13.12 19.21C13.12 19.62 13.46 19.96 13.87 19.96H16.03C18.14 19.96 19.86 18.24 19.86 16.13V14.06C19.86 13.64 19.52 13.31 19.11 13.31Z"
        fill="#898989"
      />
      <path d="M9.79999 9.48998C11.57 9.48998 13.02 8.04998 13.02 6.26998C13.02 4.48998 11.58 3.04999 9.79999 3.04999C8.01999 3.04999 6.57999 4.48998 6.57999 6.26998C6.57999 8.04998 8.02999 9.48998 9.79999 9.48998Z" />
      <path d="M12.22 10.46H7.78999C5.73999 10.46 4.07999 12.13 4.07999 14.17V14.58C4.07999 15.54 4.86999 16.33 5.82999 16.33H14.19C15.15 16.33 15.94 15.54 15.94 14.58V14.17C15.93 12.12 14.27 10.46 12.22 10.46Z" />
    </svg>
  );
}

export function AnalyticsSvg(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM11.2176 16.3256C10.9168 16.6152 10.5189 16.7823 10.1016 16.7943L10.0626 16.7727C9.64992 16.7649 9.25454 16.6052 8.95207 16.3243C8.6496 16.0434 8.46125 15.6609 8.42302 15.2498C8.42504 15.2413 8.42504 15.2324 8.42302 15.2239L7.35445 5.02704H7.34147L6.73148 10.8414V10.889C6.6697 11.2715 6.47753 11.6208 6.18757 11.8777C5.89761 12.1346 5.52771 12.2833 5.1406 12.2986C4.7535 12.3139 4.37303 12.1948 4.06372 11.9615C3.75441 11.7283 3.5353 11.3952 3.44357 11.0188L3.16669 9.82479C3.13671 9.72255 3.12791 9.61527 3.14083 9.50951C3.15375 9.40375 3.18811 9.30173 3.24182 9.20972C3.29553 9.1177 3.36746 9.03761 3.45319 8.97435C3.53893 8.91109 3.63667 8.866 3.74044 8.84183C3.84421 8.81765 3.95182 8.81491 4.05668 8.83377C4.16154 8.85262 4.26146 8.89268 4.3503 8.95149C4.43915 9.0103 4.51506 9.08662 4.57338 9.17579C4.63171 9.26495 4.67123 9.36508 4.68951 9.47004L4.96639 10.6597C4.96847 10.6729 4.97318 10.6855 4.98022 10.6968C4.98727 10.7081 4.99651 10.7179 5.00741 10.7256C5.0183 10.7332 5.03062 10.7386 5.04364 10.7414C5.05666 10.7443 5.07011 10.7444 5.0832 10.7419C5.16107 10.7376 5.19135 10.6987 5.19135 10.6597L5.78837 4.84967C5.78623 4.83388 5.78623 4.81787 5.78837 4.80208C5.85007 4.42542 6.04611 4.08385 6.34022 3.84058C6.63433 3.59731 7.00659 3.4688 7.38814 3.47883C7.76969 3.48886 8.13469 3.63674 8.41562 3.89512C8.69654 4.15351 8.87437 4.5049 8.91621 4.88428L9.98478 15.0595C9.99776 15.1417 10.0367 15.2239 10.08 15.2239C10.1232 15.2239 10.1751 15.1503 10.1751 15.0422L10.4434 12.7926C10.468 12.5872 10.5733 12.4 10.7359 12.2722C10.8986 12.1444 11.1054 12.0865 11.3108 12.1112C11.4124 12.1234 11.5107 12.1555 11.6 12.2057C11.6893 12.2559 11.7678 12.3232 11.8311 12.4038C11.9589 12.5664 12.0168 12.7732 11.9921 12.9786L11.7282 15.2282C11.7004 15.6448 11.5184 16.0361 11.2176 16.3256ZM16.8721 9.82479L16.5909 11.0318L16.5866 11.0231C16.4987 11.3876 16.2902 11.7116 15.9948 11.9425C15.6995 12.1734 15.3348 12.2977 14.9599 12.295H14.8907C14.5052 12.282 14.1361 12.1356 13.8466 11.8807C13.557 11.6259 13.3649 11.2784 13.303 10.8977L12.6886 7.55786H12.6584L12.3685 10.0151C12.3611 10.1209 12.3322 10.2241 12.2837 10.3184C12.2352 10.4127 12.168 10.4962 12.0862 10.5638C12.0045 10.6313 11.9099 10.6816 11.8081 10.7115C11.7064 10.7414 11.5996 10.7503 11.4943 10.7377C11.389 10.7251 11.2873 10.6912 11.1955 10.6381C11.1037 10.585 11.0236 10.5138 10.9601 10.4289C10.8966 10.3439 10.8511 10.247 10.8262 10.1439C10.8013 10.0408 10.7977 9.93368 10.8154 9.82912L11.1096 7.38914C11.1508 7.00962 11.3281 6.65788 11.6087 6.39902C11.8893 6.14016 12.2541 5.99172 12.6358 5.98116C13.0174 5.9706 13.3899 6.09865 13.6843 6.3416C13.9788 6.58455 14.1753 6.92595 14.2374 7.30262L14.8474 10.6424C14.8517 10.6814 14.8604 10.7419 14.9556 10.7419C14.9687 10.7444 14.9821 10.7443 14.9951 10.7414C15.0082 10.7386 15.0205 10.7332 15.0314 10.7256C15.0423 10.7179 15.0515 10.7081 15.0585 10.6968C15.0656 10.6855 15.0703 10.6729 15.0724 10.6597L15.3493 9.47004C15.3675 9.36508 15.4071 9.26495 15.4654 9.17579C15.5237 9.08662 15.5996 9.0103 15.6885 8.95149C15.7773 8.89268 15.8772 8.85262 15.9821 8.83377C16.087 8.81491 16.1946 8.81765 16.2983 8.84183C16.4021 8.866 16.4998 8.91109 16.5856 8.97435C16.6713 9.03761 16.7432 9.1177 16.7969 9.20972C16.8507 9.30173 16.885 9.40375 16.8979 9.50951C16.9109 9.61527 16.9021 9.72255 16.8721 9.82479Z"
      />
    </svg>
  );
}

export function HotIcon() {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2_615)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.23666 20C1.26473 20.0346 -2.57719 10.915 1.98857 5.68032C2.22473 5.39814 2.52459 5.18801 2.85843 5.07078C3.19228 4.95354 3.54849 4.93327 3.89176 5.01197C4.23502 5.09067 4.55341 5.26561 4.81535 5.51944C5.07729 5.77327 5.27368 6.09718 5.38505 6.45903C5.40531 6.5188 5.41737 6.58148 5.42084 6.64506C5.46162 6.72037 5.52473 6.77834 5.59981 6.80946C5.64776 6.83381 5.70002 6.84643 5.75293 6.84643C5.80584 6.84643 5.85811 6.83381 5.90605 6.80946C7.05545 6.16053 7.2026 4.64636 7.34976 2.2583V2.02901C7.3726 1.64725 7.48811 1.27891 7.68451 0.961555C7.88092 0.644198 8.15118 0.389177 8.46775 0.2225C8.78431 0.0558235 9.13585 -0.0165467 9.48652 0.0127701C9.83718 0.042087 10.1744 0.172042 10.4639 0.389382C13.2717 2.51354 14.6041 5.6933 15.1489 7.40215C15.1797 7.49901 15.1927 7.60153 15.1871 7.70385C15.1815 7.80617 15.1574 7.90628 15.1162 7.99848C15.0751 8.09067 15.0176 8.17314 14.9471 8.24118C14.8766 8.30922 14.7945 8.36149 14.7055 8.39501C14.6164 8.42853 14.5222 8.44264 14.4281 8.43654C14.3341 8.43044 14.242 8.40424 14.1573 8.35945C14.0725 8.31466 13.9967 8.25214 13.9341 8.17548C13.8716 8.09882 13.8235 8.0095 13.7927 7.91264C13.3035 6.38549 12.1184 3.54318 9.64457 1.67426C9.56391 1.6116 9.46907 1.57406 9.37026 1.56567C9.27145 1.55728 9.1724 1.57838 9.08379 1.62667C8.99653 1.67109 8.92197 1.74041 8.86805 1.82726C8.81412 1.9141 8.78285 2.01522 8.77755 2.11986V2.34482C8.66221 4.55551 8.46336 7.1469 6.56626 8.17653C6.33732 8.3081 6.08496 8.38432 5.82643 8.39998C5.56791 8.41563 5.30933 8.37035 5.06838 8.26724C4.82743 8.16413 4.6098 8.00561 4.43038 7.80254C4.25097 7.59947 4.114 7.35664 4.02884 7.09066C4.00959 7.02444 3.99627 6.95634 3.98907 6.88733C3.9523 6.79937 3.89723 6.72192 3.8282 6.6611C3.75918 6.60028 3.67809 6.55776 3.59136 6.53691C3.49343 6.51383 3.39161 6.51972 3.29649 6.55396C3.20137 6.5882 3.11641 6.64953 3.05046 6.73158C-1.567 12.3556 4.56178 20.9648 11.0962 17.7634C11.2666 17.6935 11.455 17.6965 11.6234 17.7717C11.7919 17.8469 11.9279 17.9887 12.004 18.1686C12.0802 18.3486 12.0908 18.5532 12.0338 18.7413C11.9768 18.9294 11.8564 19.087 11.6968 19.1824C10.618 19.7228 9.4442 20.0018 8.25655 20H8.23666ZM15.7932 16.9284C17.4517 15.5787 18.3466 13.9607 18.3784 12.2475C18.3821 11.7482 18.2506 11.2587 18.0003 10.8401C17.7501 10.4215 17.3921 10.0923 16.971 9.89353C16.5499 9.69472 16.0843 9.63511 15.6323 9.72213C15.1803 9.80915 14.7618 10.039 14.4291 10.3829C14.097 10.0397 13.6797 9.8102 13.2288 9.72276C12.7779 9.63532 12.3133 9.69383 11.8927 9.89103C11.4721 10.0882 11.114 10.4154 10.8628 10.832C10.6116 11.2486 10.4784 11.7363 10.4798 12.2345C10.5116 13.965 11.4025 15.5657 13.0609 16.9154C13.4567 17.2327 13.9354 17.4039 14.4271 17.4039C14.9187 17.4039 15.3975 17.2327 15.7932 16.9154V16.9284ZM12.8104 11.2481C12.5755 11.2538 12.3519 11.3593 12.1876 11.542C12.0233 11.7248 11.9314 11.9703 11.9314 12.2259C11.9632 13.753 13.041 14.947 13.92 15.6868C14.0661 15.8048 14.2432 15.8685 14.4251 15.8685C14.607 15.8685 14.7841 15.8048 14.9302 15.6868C15.829 14.9557 16.9188 13.7617 16.9386 12.2259C16.9386 11.9665 16.844 11.7179 16.6754 11.5345C16.5068 11.3511 16.2782 11.2481 16.0398 11.2481C15.8014 11.2481 15.5728 11.3511 15.4042 11.5345C15.2357 11.7179 15.141 11.9665 15.141 12.2259C15.1275 12.4229 15.046 12.6071 14.9129 12.7416C14.7797 12.876 14.6048 12.9507 14.4231 12.9507C14.2414 12.9507 14.0665 12.876 13.9334 12.7416C13.8002 12.6071 13.7187 12.4229 13.7052 12.2259C13.7052 11.9673 13.6111 11.7193 13.4434 11.536C13.2757 11.3528 13.0481 11.2493 12.8104 11.2481ZM16.5807 2.96347C16.5655 2.71596 16.4645 2.48398 16.2979 2.31451C16.1314 2.14503 15.9119 2.05075 15.6839 2.05075C15.4558 2.05075 15.2363 2.14503 15.0698 2.31451C14.9033 2.48398 14.8022 2.71596 14.787 2.96347C14.787 3.89793 15.3796 4.65501 16.0637 5.20444C16.2146 5.32507 16.3974 5.38904 16.5847 5.3867C16.7719 5.38435 16.9534 5.31583 17.1017 5.19146C17.7858 4.64203 18.3585 3.8936 18.3784 2.95049C18.3768 2.69118 18.2806 2.44318 18.1109 2.26104C18.0269 2.17085 17.9273 2.09955 17.818 2.0512C17.7086 2.00285 17.5916 1.97841 17.4736 1.97926C17.3555 1.98011 17.2388 2.00624 17.1301 2.05617C17.0213 2.10609 16.9227 2.17882 16.8398 2.27022C16.6723 2.45479 16.5791 2.70416 16.5807 2.96347Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_615">
          <rect width="18.3784" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function NotificationIcon() {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.01515 18.1083C7.26765 18.1083 5.52015 17.8 3.86265 17.1833C3.23265 16.9416 2.75265 16.45 2.54265 15.8083C2.32515 15.1666 2.40015 14.4583 2.74515 13.825L3.60765 12.2333C3.78765 11.9 3.95265 11.2333 3.95265 10.8416L3.95265 8.43329C3.95265 5.33329 6.22515 2.80829 9.01515 2.80829C11.8051 2.80829 14.0776 5.33329 14.0776 8.43329V10.8416C14.0776 11.225 14.2426 11.9 14.4226 12.2416L15.2776 13.825C15.6001 14.425 15.6601 15.15 15.4426 15.8083C15.2251 16.4666 14.7526 16.9666 14.1601 17.1833C12.5101 17.8 10.7626 18.1083 9.01515 18.1083ZM9.01515 4.05829C6.84765 4.05829 5.07765 6.01662 5.07765 8.43329L5.07765 10.8416C5.07765 11.45 4.85265 12.35 4.57515 12.875L3.71265 14.4666C3.54765 14.775 3.50265 15.1 3.60015 15.375C3.69015 15.6583 3.91515 15.875 4.22265 15.9916C7.35765 17.1583 10.6801 17.1583 13.8151 15.9916C14.0851 15.8916 14.2951 15.6666 14.3926 15.3666C14.4901 15.0666 14.4676 14.7416 14.3176 14.4666L13.4551 12.875C13.1701 12.3333 12.9526 11.4416 12.9526 10.8333V8.43329C12.9526 6.01662 11.1901 4.05829 9.01515 4.05829Z"
        fill="#898989"
      />
      <path
        d="M10.4101 4.28326C10.3576 4.28326 10.3051 4.27493 10.2526 4.25826C10.0351 4.19159 9.82509 4.14159 9.62259 4.10826C8.98509 4.01659 8.37009 4.06659 7.79259 4.25826C7.58259 4.33326 7.35759 4.25826 7.21509 4.08326C7.07259 3.90826 7.02759 3.65826 7.11009 3.43326C7.41759 2.55826 8.16759 1.98326 9.02259 1.98326C9.87759 1.98326 10.6276 2.54993 10.9351 3.43326C11.0101 3.65826 10.9726 3.90826 10.8301 4.08326C10.7176 4.21659 10.5601 4.28326 10.4101 4.28326Z"
        fill="#898989"
      />
      <path
        d="M9.01514 20.0083C8.27264 20.0083 7.55264 19.675 7.02764 19.0917C6.50264 18.5083 6.20264 17.7083 6.20264 16.8833H7.32764C7.32764 17.375 7.50764 17.8583 7.82264 18.2083C8.13764 18.5583 8.57264 18.7583 9.01514 18.7583C9.94514 18.7583 10.7026 17.9167 10.7026 16.8833H11.8276C11.8276 18.6083 10.5676 20.0083 9.01514 20.0083Z"
        fill="#898989"
      />
      <path
        d="M13.5 9.48531C15.8031 9.48531 17.5853 7.42784 17.5853 5.00006C17.5853 2.57228 15.8031 0.514812 13.5 0.514812C11.197 0.514812 9.41478 2.57228 9.41478 5.00006C9.41478 7.42784 11.197 9.48531 13.5 9.48531Z"
        fill="#00B85E"
        stroke="#1E1E1E"
        stroke-width="0.970498"
      />
    </svg>
  );
}

export function SettingIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" fill="white" />
      <path
        d="M10 13.125C8.275 13.125 6.875 11.725 6.875 9.99997C6.875 8.27497 8.275 6.87497 10 6.87497C11.725 6.87497 13.125 8.27497 13.125 9.99997C13.125 11.725 11.725 13.125 10 13.125ZM10 8.12497C8.96667 8.12497 8.125 8.96664 8.125 9.99997C8.125 11.0333 8.96667 11.875 10 11.875C11.0333 11.875 11.875 11.0333 11.875 9.99997C11.875 8.96664 11.0333 8.12497 10 8.12497Z"
        fill="#898989"
      />
      <path
        d="M12.675 18.4917C12.5 18.4917 12.325 18.4667 12.15 18.425C11.6333 18.2834 11.2 17.9584 10.925 17.5L10.825 17.3334C10.3333 16.4834 9.65829 16.4834 9.16663 17.3334L9.07496 17.4917C8.79996 17.9584 8.36663 18.2917 7.84996 18.425C7.32496 18.5667 6.78329 18.4917 6.32496 18.2167L4.89163 17.3917C4.38329 17.1 4.01663 16.625 3.85829 16.05C3.70829 15.475 3.78329 14.8834 4.07496 14.375C4.31663 13.95 4.38329 13.5667 4.24163 13.325C4.09996 13.0834 3.74163 12.9417 3.24996 12.9417C2.03329 12.9417 1.04163 11.95 1.04163 10.7334L1.04163 9.2667C1.04163 8.05003 2.03329 7.05836 3.24996 7.05836C3.74163 7.05836 4.09996 6.9167 4.24163 6.67503C4.38329 6.43336 4.32496 6.05003 4.07496 5.62503C3.78329 5.1167 3.70829 4.5167 3.85829 3.95003C4.00829 3.37503 4.37496 2.90003 4.89163 2.60836L6.33329 1.78336C7.27496 1.22503 8.51663 1.55003 9.08329 2.50836L9.18329 2.67503C9.67496 3.52503 10.35 3.52503 10.8416 2.67503L10.9333 2.5167C11.5 1.55003 12.7416 1.22503 13.6916 1.7917L15.125 2.6167C15.6333 2.90836 16 3.38336 16.1583 3.95836C16.3083 4.53336 16.2333 5.12503 15.9416 5.63336C15.7 6.05836 15.6333 6.4417 15.775 6.68336C15.9166 6.92503 16.275 7.0667 16.7666 7.0667C17.9833 7.0667 18.975 8.05836 18.975 9.27503V10.7417C18.975 11.9584 17.9833 12.95 16.7666 12.95C16.275 12.95 15.9166 13.0917 15.775 13.3334C15.6333 13.575 15.6916 13.9584 15.9416 14.3834C16.2333 14.8917 16.3166 15.4917 16.1583 16.0584C16.0083 16.6334 15.6416 17.1084 15.125 17.4L13.6833 18.225C13.3666 18.4 13.025 18.4917 12.675 18.4917ZM9.99996 15.4084C10.7416 15.4084 11.4333 15.875 11.9083 16.7L12 16.8584C12.1 17.0334 12.2666 17.1584 12.4666 17.2084C12.6666 17.2584 12.8666 17.2334 13.0333 17.1334L14.475 16.3C14.6916 16.175 14.8583 15.9667 14.925 15.7167C14.9916 15.4667 14.9583 15.2084 14.8333 14.9917C14.3583 14.175 14.3 13.3334 14.6666 12.6917C15.0333 12.05 15.7916 11.6834 16.7416 11.6834C17.275 11.6834 17.7 11.2584 17.7 10.725V9.25836C17.7 8.73336 17.275 8.30003 16.7416 8.30003C15.7916 8.30003 15.0333 7.93336 14.6666 7.2917C14.3 6.65003 14.3583 5.80836 14.8333 4.9917C14.9583 4.77503 14.9916 4.5167 14.925 4.2667C14.8583 4.0167 14.7 3.8167 14.4833 3.68336L13.0416 2.85836C12.6833 2.6417 12.2083 2.7667 11.9916 3.13336L11.9 3.2917C11.425 4.1167 10.7333 4.58336 9.99163 4.58336C9.24996 4.58336 8.55829 4.1167 8.08329 3.2917L7.99163 3.12503C7.78329 2.77503 7.31663 2.65003 6.95829 2.85836L5.51663 3.6917C5.29996 3.8167 5.13329 4.02503 5.06663 4.27503C4.99996 4.52503 5.03329 4.78336 5.15829 5.00003C5.63329 5.8167 5.69163 6.65836 5.32496 7.30003C4.95829 7.9417 4.19996 8.30836 3.24996 8.30836C2.71663 8.30836 2.29163 8.73336 2.29163 9.2667L2.29163 10.7334C2.29163 11.2584 2.71663 11.6917 3.24996 11.6917C4.19996 11.6917 4.95829 12.0584 5.32496 12.7C5.69163 13.3417 5.63329 14.1834 5.15829 15C5.03329 15.2167 4.99996 15.475 5.06663 15.725C5.13329 15.975 5.29163 16.175 5.50829 16.3084L6.94996 17.1334C7.12496 17.2417 7.33329 17.2667 7.52496 17.2167C7.72496 17.1667 7.89163 17.0334 7.99996 16.8584L8.09163 16.7C8.56663 15.8834 9.25829 15.4084 9.99996 15.4084Z"
        fill="#898989"
      />
    </svg>
  );
}

export function TranslateIcon() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.57417 14.4404C9.01107 14.8807 9.25624 15.4757 9.25624 16.096C9.25624 16.7162 9.01107 17.3113 8.57417 17.7515L7.27571 19.05C7.20296 19.1221 7.1167 19.1793 7.02186 19.2181C6.92702 19.257 6.82545 19.2768 6.72297 19.2764C6.62048 19.276 6.51907 19.2554 6.42454 19.2158C6.33001 19.1762 6.2442 19.1184 6.17202 19.0456C6.09983 18.9729 6.04268 18.8866 6.00383 18.7918C5.96499 18.6969 5.9452 18.5954 5.9456 18.4929C5.946 18.3904 5.96659 18.289 6.00618 18.1945C6.04577 18.0999 6.10359 18.0141 6.17635 17.9419L7.47481 16.6435C7.54652 16.5719 7.60342 16.4869 7.64224 16.3933C7.68106 16.2998 7.70104 16.1994 7.70104 16.0981C7.70104 15.9968 7.68106 15.8965 7.64224 15.8029C7.60342 15.7093 7.54652 15.6243 7.47481 15.5528L6.17635 14.2889C6.04168 14.1414 5.96845 13.948 5.97162 13.7483C5.9748 13.5486 6.05415 13.3576 6.19344 13.2145C6.33274 13.0713 6.52146 12.9867 6.72101 12.9781C6.92057 12.9694 7.1159 13.0374 7.26705 13.1679L8.56551 14.4361L8.57417 14.4404ZM6.17635 16.0245C6.17635 15.8168 6.09381 15.6175 5.94689 15.4706C5.79997 15.3237 5.60071 15.2411 5.39294 15.2411H4.69177C3.86482 15.2412 3.07149 14.9138 2.48513 14.3307C1.89877 13.7476 1.56706 12.9561 1.56248 12.1292V10.2897C1.5478 10.0925 1.45911 9.90821 1.31422 9.77371C1.16933 9.63921 0.978939 9.56446 0.781241 9.56446C0.583542 9.56446 0.393153 9.63921 0.24826 9.77371C0.103367 9.90821 0.0146847 10.0925 0 10.2897V12.1292C0.00343129 13.372 0.498981 14.563 1.37824 15.4414C2.2575 16.3199 3.44889 16.8143 4.69177 16.8166H5.39294C5.49655 16.8166 5.59913 16.7961 5.69475 16.7562C5.79037 16.7162 5.87711 16.6578 5.94997 16.5841C6.02283 16.5104 6.08036 16.423 6.11922 16.327C6.15807 16.231 6.17749 16.1282 6.17635 16.0245ZM13.8502 5.81864L12.5518 4.55481C12.4096 4.41064 12.3299 4.21628 12.3299 4.01378C12.3299 3.81128 12.4096 3.61693 12.5518 3.47276L13.8502 2.1743C13.9304 2.1036 13.9953 2.01725 14.0408 1.92056C14.0864 1.82387 14.1116 1.71887 14.1151 1.61205C14.1186 1.50522 14.1001 1.39881 14.0609 1.29938C14.0217 1.19994 13.9626 1.10958 13.8871 1.03386C13.8117 0.958131 13.7216 0.898641 13.6223 0.859049C13.523 0.819456 13.4167 0.800598 13.3098 0.803635C13.203 0.806672 13.0979 0.831539 13.001 0.876708C12.9042 0.921876 12.8176 0.986389 12.7466 1.06628L11.4481 2.36474C11.0091 2.80385 10.7625 3.39935 10.7625 4.02028C10.7625 4.6412 11.0091 5.2367 11.4481 5.67581L12.7466 6.94398C12.8204 7.01645 12.9079 7.07365 13.0039 7.11233C13.0999 7.151 13.2026 7.17039 13.3061 7.16939C13.4095 7.16839 13.5118 7.14701 13.6071 7.10647C13.7023 7.06594 13.7886 7.00705 13.8611 6.93316C13.9335 6.85927 13.9907 6.77183 14.0294 6.67583C14.0681 6.57983 14.0875 6.47715 14.0865 6.37366C14.0855 6.27017 14.0641 6.16789 14.0236 6.07266C13.983 5.97743 13.9241 5.89111 13.8502 5.81864ZM15.3348 3.29097C16.5755 3.29783 17.7631 3.79489 18.6387 4.67378C19.5144 5.55267 20.007 6.7421 20.0093 7.98275V9.8179C19.9946 10.0151 19.9059 10.1994 19.761 10.3339C19.6161 10.4684 19.4257 10.5431 19.228 10.5431C19.0303 10.5431 18.84 10.4684 18.6951 10.3339C18.5502 10.1994 18.4615 10.0151 18.4468 9.8179V7.98275C18.4457 7.15356 18.1155 6.35872 17.5287 5.7728C16.942 5.18688 16.1467 4.85778 15.3175 4.85778H14.6163C14.4086 4.85778 14.2093 4.77525 14.0624 4.62833C13.9155 4.48141 13.8329 4.28215 13.8329 4.07438C13.8329 3.86661 13.9155 3.66735 14.0624 3.52043C14.2093 3.37351 14.4086 3.29097 14.6163 3.29097H15.3348ZM7.60898 1.40388C7.50076 1.00106 7.26271 0.645174 6.93171 0.391367C6.60072 0.13756 6.19526 0 5.77815 0C5.36105 0 4.95559 0.13756 4.62459 0.391367C4.29359 0.645174 4.05554 1.00106 3.94732 1.40388L2.67916 6.93532C2.64756 7.13155 2.69173 7.33245 2.80272 7.49733C2.91371 7.66222 3.08322 7.77875 3.27692 7.82332C3.47061 7.86789 3.67401 7.83717 3.8459 7.73739C4.0178 7.6376 4.14534 7.47621 4.20268 7.2859L4.4191 6.32937H7.17616L7.40556 7.29023C7.42385 7.39525 7.46339 7.49542 7.52174 7.58463C7.58009 7.67383 7.65604 7.75019 7.74493 7.80902C7.83381 7.86786 7.93377 7.90794 8.03868 7.9268C8.1436 7.94567 8.25126 7.94292 8.35507 7.91874C8.45889 7.89456 8.55668 7.84944 8.64245 7.78615C8.72823 7.72287 8.80018 7.64274 8.85392 7.55068C8.90765 7.45862 8.94203 7.35656 8.95496 7.25075C8.96788 7.14494 8.95908 7.03761 8.92908 6.93532L7.60898 1.40388ZM4.76102 4.77122L5.43189 1.84535C5.44714 1.76876 5.48847 1.69981 5.54884 1.65027C5.60922 1.60072 5.6849 1.57364 5.763 1.57364C5.8411 1.57364 5.91679 1.60072 5.97716 1.65027C6.03754 1.69981 6.07887 1.76876 6.09411 1.84535L6.80826 4.77122H4.76102ZM16.3996 17.4485C16.2648 17.6404 16.1203 17.8253 15.9667 18.0025C16.5351 18.2998 17.1693 18.4486 17.8106 18.4354C17.918 18.4273 18.026 18.4416 18.1277 18.4772C18.2295 18.5129 18.3227 18.5691 18.4017 18.6424C18.4807 18.7158 18.5437 18.8046 18.5868 18.9034C18.6299 19.0022 18.6521 19.1088 18.6521 19.2166C18.6521 19.3244 18.6299 19.431 18.5868 19.5298C18.5437 19.6286 18.4807 19.7174 18.4017 19.7908C18.3227 19.8641 18.2295 19.9203 18.1277 19.9559C18.026 19.9916 17.918 20.0058 17.8106 19.9978C16.7307 20.0039 15.6743 19.6825 14.7808 19.0759C13.8883 19.6845 12.8313 20.0061 11.7511 19.9978C11.6436 20.0058 11.5356 19.9916 11.4339 19.9559C11.3322 19.9203 11.2389 19.8641 11.1599 19.7908C11.0809 19.7174 11.0179 19.6286 10.9748 19.5298C10.9317 19.431 10.9095 19.3244 10.9095 19.2166C10.9095 19.1088 10.9317 19.0022 10.9748 18.9034C11.0179 18.8046 11.0809 18.7158 11.1599 18.6424C11.2389 18.5691 11.3322 18.5129 11.4339 18.4772C11.5356 18.4416 11.6436 18.4273 11.7511 18.4354C12.3908 18.4475 13.0234 18.2987 13.5906 18.0025C13.34 17.7055 13.1142 17.3885 12.9154 17.0547C12.8534 16.9665 12.8104 16.8664 12.7889 16.7608C12.7673 16.6552 12.7678 16.5463 12.7903 16.4409C12.8128 16.3356 12.8568 16.2359 12.9196 16.1483C12.9823 16.0607 13.0625 15.987 13.155 15.9318C13.2476 15.8765 13.3505 15.841 13.4574 15.8274C13.5643 15.8137 13.6729 15.8223 13.7763 15.8525C13.8798 15.8828 13.9758 15.934 14.0586 16.0031C14.1413 16.0722 14.2089 16.1576 14.2571 16.2539C14.4152 16.5192 14.5947 16.7711 14.7938 17.007C14.9156 16.8691 15.0297 16.7246 15.1357 16.5742C15.5662 15.9364 15.8798 15.227 16.062 14.4794H11.4914C11.2942 14.4647 11.1099 14.376 10.9754 14.2311C10.8409 14.0862 10.7662 13.8958 10.7662 13.6981C10.7662 13.5004 10.8409 13.3101 10.9754 13.1652C11.1099 13.0203 11.2942 12.9316 11.4914 12.9169H14.0277V12.1292C14.0522 11.9404 14.1445 11.767 14.2875 11.6414C14.4304 11.5157 14.6143 11.4464 14.8046 11.4464C14.995 11.4464 15.1788 11.5157 15.3218 11.6414C15.4647 11.767 15.5571 11.9404 15.5815 12.1292V12.9082H18.0399C18.2371 12.9229 18.4214 13.0116 18.5559 13.1565C18.6904 13.3014 18.7652 13.4918 18.7652 13.6895C18.7652 13.8872 18.6904 14.0776 18.5559 14.2225C18.4214 14.3674 18.2371 14.456 18.0399 14.4707H17.6071C17.4126 15.5384 16.9953 16.553 16.3822 17.4485H16.3996Z"
        fill="#5843BD"
      />
    </svg>
  );
}

export function MenuIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 11H26"
        stroke="black"
        stroke-opacity="0.6"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 24.7144H26"
        stroke="black"
        stroke-opacity="0.6"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 17.857H26"
        stroke="black"
        stroke-opacity="0.6"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="0.5"
        y="0.5"
        width="35"
        height="34.7143"
        rx="5.5"
        stroke="black"
        stroke-opacity="0.3"
      />
    </svg>
  );
}

export function SearchIcon(props) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M9.88649 18.773C4.97838 18.773 1 14.7946 1 9.88649C1 4.97838 4.97838 1 9.88649 1C14.7946 1 18.773 4.97838 18.773 9.88649C18.773 14.7946 14.7946 18.773 9.88649 18.773Z"
        stroke="#898989"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.0001 21L16.5569 16.5568"
        stroke="#898989"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function AnalyticsOptionsSvg(props) {
  return (
    <svg
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.52783 0C4.10955 0 0.527832 3.58172 0.527832 8V25C0.527832 29.4183 4.10955 33 8.52783 33H25.5278C29.9461 33 33.5278 29.4183 33.5278 25V8C33.5278 3.58172 29.9461 0 25.5278 0H8.52783ZM27.8347 21.2549C28.077 21.0126 28.2131 20.684 28.2131 20.3413C28.2131 20.0006 28.0777 19.6738 27.8368 19.4328C27.5958 19.1918 27.269 19.0565 26.9282 19.0565H17.1346C16.8094 19.0807 16.5055 19.2269 16.2836 19.4659C16.0618 19.7049 15.9385 20.0189 15.9385 20.3449C15.9385 20.671 16.0618 20.985 16.2836 21.2239C16.5055 21.4629 16.8094 21.6091 17.1346 21.6334H26.9211C27.2637 21.6334 27.5924 21.4972 27.8347 21.2549ZM17.1274 23.9533H22.4097C22.7349 23.9775 23.0388 24.1238 23.2607 24.3627C23.4825 24.6017 23.6058 24.9157 23.6058 25.2417C23.6058 25.5678 23.4825 25.8818 23.2607 26.1207C23.0388 26.3597 22.7349 26.506 22.4097 26.5302H17.1274C16.8023 26.506 16.4983 26.3597 16.2765 26.1207C16.0547 25.8818 15.9314 25.5678 15.9314 25.2417C15.9314 24.9157 16.0547 24.6017 16.2765 24.3627C16.4983 24.1238 16.8023 23.9775 17.1274 23.9533ZM27.8418 14.5166C27.5995 14.2743 27.2709 14.1382 26.9282 14.1382H17.1346C16.7919 14.1382 16.4633 14.2743 16.221 14.5166C15.9787 14.7589 15.8426 15.0876 15.8426 15.4302C15.8426 15.7729 15.9787 16.1015 16.221 16.3438C16.4633 16.5861 16.7919 16.7223 17.1346 16.7223H26.9282C27.2709 16.7223 27.5995 16.5861 27.8418 16.3438C28.0841 16.1015 28.2202 15.7729 28.2202 15.4302C28.2202 15.0876 28.0841 14.7589 27.8418 14.5166ZM12.8562 17.5875C13.0952 17.3657 13.2414 17.0617 13.2657 16.7365C13.2657 15.7104 12.858 14.7264 12.1325 14.0008C11.4069 13.2752 10.4228 12.8676 9.39675 12.8676C8.37065 12.8676 7.38657 13.2752 6.66101 14.0008C5.93545 14.7264 5.52783 15.7104 5.52783 16.7365V25.2382C5.52783 25.5808 5.66395 25.9095 5.90626 26.1518C6.14856 26.3941 6.47719 26.5302 6.81985 26.5302C7.16251 26.5302 7.49114 26.3941 7.73344 26.1518C7.97575 25.9095 8.11187 25.5808 8.11187 25.2382V22.2758H9.39675C9.7219 22.2516 10.0259 22.1053 10.2477 21.8664C10.4695 21.6274 10.5928 21.3134 10.5928 20.9873C10.5928 20.6613 10.4695 20.3473 10.2477 20.1083C10.0259 19.8694 9.7219 19.7231 9.39675 19.6989H8.11187V16.7365C8.13609 16.4114 8.28234 16.1074 8.52131 15.8856C8.76027 15.6638 9.07427 15.5405 9.40032 15.5405C9.72637 15.5405 10.0404 15.6638 10.2793 15.8856C10.5183 16.1074 10.6645 16.4114 10.6888 16.7365C10.713 17.0617 10.8592 17.3657 11.0982 17.5875C11.3372 17.8093 11.6512 17.9326 11.9772 17.9326C12.3033 17.9326 12.6173 17.8093 12.8562 17.5875ZM27.7792 7.40944C27.5573 7.17048 27.2534 7.02422 26.9282 7H6.79844C6.47328 7.02422 6.16931 7.17048 5.94749 7.40944C5.72566 7.6484 5.60239 7.9624 5.60239 8.28845C5.60239 8.6145 5.72566 8.9285 5.94749 9.16746C6.16931 9.40642 6.47328 9.55268 6.79844 9.5769H26.9282C27.2534 9.55268 27.5573 9.40642 27.7792 9.16746C28.001 8.9285 28.1243 8.6145 28.1243 8.28845C28.1243 7.9624 28.001 7.6484 27.7792 7.40944Z"
        fill="white"
      />
    </svg>
  );
}

export function SendSvg() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2305 18.1437H3.48174"
        stroke="#313131"
        stroke-width="1.45575"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.0176 3.18179L4.6951 14.5043"
        stroke="#313131"
        stroke-width="1.45575"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.0176 11.4876V3.18179L7.71173 3.18179"
        stroke="#313131"
        stroke-width="1.45575"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function SmallSendSvg() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6665 15.1665H2.33317"
        stroke="white"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6665 2.8335L3.33317 12.1668"
        stroke="white"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6665 9.68016V2.8335H5.81984"
        stroke="white"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function AddIcon(props) {
  return (
    <svg
      className={props.className}
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_39_3039)">
        <circle cx="43" cy="43" r="36" fill="white" />
        <circle
          cx="43"
          cy="43"
          r="35.25"
          stroke="white"
          stroke-opacity="0.3"
          stroke-width="1.5"
        />
      </g>
      <path
        d="M42.7198 26.2802L42.9706 59.9706"
        stroke="#5843BD"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26 43L59.6903 43.2508"
        stroke="#5843BD"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_39_3039"
          x="0"
          y="0"
          width="86"
          height="86"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_39_3039"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_39_3039"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function ExperienceIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_37_1204)">
        <path
          d="M7.81572 2.85732L0.69873 6.73932L3.28673 8.14977L3.28673 12.0318L7.81572 14.5033L12.3447 12.0318L12.3447 8.14977L13.6387 7.44454L13.6387 11.9153H14.9327L14.9327 6.73932L7.81572 2.85732ZM12.2283 6.73932L7.81572 9.14615L3.40319 6.73932L7.81572 4.33248L12.2283 6.73932ZM11.0507 11.2618L7.81572 13.0281L4.58072 11.2618L4.58072 8.855L7.81572 10.6213L11.0507 8.855L11.0507 11.2618Z"
          fill="#898989"
        />
      </g>
      <defs>
        <clipPath id="clip0_37_1204">
          <rect
            width="15.528"
            height="15.528"
            fill="white"
            transform="translate(0.0517578 0.916527)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function LocationIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_37_1169)">
        <path
          d="M7.93768 2.21039C5.4338 2.21039 3.40869 4.23549 3.40869 6.73938C3.40869 10.1361 7.93768 15.1504 7.93768 15.1504C7.93768 15.1504 12.4667 10.1361 12.4667 6.73938C12.4667 4.23549 10.4416 2.21039 7.93768 2.21039ZM4.70269 6.73938C4.70269 4.95366 6.15197 3.50439 7.93768 3.50439C9.7234 3.50439 11.1727 4.95366 11.1727 6.73938C11.1727 8.60274 9.30932 11.3913 7.93768 13.1317C6.59193 11.4042 4.70269 8.58333 4.70269 6.73938Z"
          fill="#898989"
        />
        <path
          d="M7.93781 8.35696C8.83113 8.35696 9.55531 7.63278 9.55531 6.73946C9.55531 5.84614 8.83113 5.12196 7.93781 5.12196C7.04449 5.12196 6.32031 5.84614 6.32031 6.73946C6.32031 7.63278 7.04449 8.35696 7.93781 8.35696Z"
          fill="#898989"
        />
      </g>
      <defs>
        <clipPath id="clip0_37_1169">
          <rect
            width="15.528"
            height="15.528"
            fill="white"
            transform="translate(0.173828 0.916527)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TickSvg() {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21" r="21" fill="#898989" fill-opacity="0.3" />
      <path
        d="M10.625 20.8367L17.7239 27.5489L31.921 14.1245"
        stroke="white"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function DeleteBox() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5563 7.67041V17.6704C16.5563 19.5082 15.0644 21.0002 13.2266 21.0002H6.55629C4.71846 21.0002 3.22656 19.5082 3.22656 17.6704V7.67041"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 4.32959H18.773"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.55664 4.32975C6.55664 2.49191 8.04853 1 9.88637 1C11.7242 1 13.2161 2.49191 13.2161 4.32975"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.65918 11L12.1132 15.4432"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.1132 11L7.65918 15.4432"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ZoomSvg(props) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <rect width="32" height="32" rx="10" fill="#4087FC" />
      <path
        d="M7.16149 9.14307C6.36199 9.14307 5.71387 9.87403 5.71387 10.7757V18.6941C5.71387 20.9934 7.36658 22.8574 9.4053 22.8574L17.9805 22.7757C18.78 22.7757 19.4282 22.0448 19.4282 21.1431V13.1431C19.4282 10.8438 17.4669 9.14309 15.4282 9.14309L7.16149 9.14307Z"
        fill="white"
      />
      <path
        d="M21.385 12.2603C20.8676 12.7718 20.571 13.51 20.571 14.286V17.5994C20.571 18.3753 20.8676 19.1135 21.385 19.625L24.6039 22.4602C25.2589 23.1078 26.2853 22.5832 26.2853 21.6008V10.4404C26.2853 9.45798 25.2589 8.93339 24.6039 9.58104L21.385 12.2603Z"
        fill="white"
      />
    </svg>
  );
}

export function DropboxSvg() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#0F287F" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.6662 10.0481L22.327 13.481L15.9995 9.62097L20.3907 6L26.6662 10.0481ZM11.6085 6.00002L15.9995 9.62097L9.67226 13.481L5.33303 10.0481L11.6085 6.00002ZM15.9996 17.3412L11.6085 20.9624L5.33301 16.9143L9.67226 13.481L15.9996 17.3412ZM15.9996 17.3412L22.327 13.481L26.6662 16.9142L20.3907 20.9623L15.9996 17.3412ZM20.4165 21.7307L16.0125 18.1202L11.6085 21.7307L9.72384 20.5151V21.8779L16.0125 25.6036L22.3012 21.8779V20.5151L20.4165 21.7307Z"
        fill="#DAF8FE"
      />
    </svg>
  );
}

export function SortSvg() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="inline mb-[4px]"
    >
      <path
        d="M6.0459 12.0415L9.44264 15.2765L12.8394 12.0415L6.0459 12.0415Z"
        fill="black"
      />
      <path
        d="M6.0459 9.77734L9.44264 6.54235L12.8394 9.77734L6.0459 9.77734Z"
        fill="black"
      />
    </svg>
  );
}

export function RatingSvg() {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="inline mb-[4px]"
    >
      <path
        d="M8.16078 3.24128L9.20687 5.51872C9.34952 5.83575 9.72992 6.13983 10.0509 6.19806L11.9469 6.54097C13.1594 6.76095 13.4447 7.71851 12.571 8.66313L11.097 10.2677C10.8473 10.5394 10.7106 11.0635 10.7879 11.4388L11.2099 13.425C11.5427 14.9973 10.776 15.6054 9.49811 14.7837L7.72094 13.6386C7.39999 13.4315 6.871 13.4315 6.54409 13.6386L4.76693 14.7837C3.49497 15.6054 2.72229 14.9908 3.05514 13.425L3.47714 11.4388C3.55441 11.0635 3.41771 10.5394 3.16807 10.2677L1.69403 8.66313C0.826253 7.71851 1.10561 6.76095 2.31812 6.54097L4.21416 6.19806C4.52918 6.13983 4.90957 5.83575 5.05222 5.51872L6.09832 3.24128C6.66891 2.00551 7.59613 2.00551 8.16078 3.24128Z"
        fill="#FF6633"
      />
    </svg>
  );
}

export function VectorSvg(props) {
  return (
    <svg
      width="317"
      height="193"
      viewBox="0 0 317 193"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M208.594 1H19.7465C13.4516 1 0.861722 4.72646 0.861722 19.6323V167.894C0.262204 175.995 4.09911 192.197 24.2429 192.197H294.026C303.804 192.197 315.608 185 315.608 171.5V82.5886C315.608 68.5784 312.787 51.6838 290.485 51.6838H267.409C261.228 51.6838 251.663 51.6838 241.861 47.5632C237.365 45.6729 226.615 38.4978 227.851 17.4825C228.384 8.41714 220.434 1 208.594 1Z"
        fill="#777DEA"
        fill-opacity="0.25"
        stroke="#777DEA"
        stroke-opacity="0.5"
      />
    </svg>
  );
}

export function StarTrue() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5251 5.92292L9.958 8.41956C9.84498 8.51559 9.79652 8.67564 9.82881 8.83568L10.4423 12.3406C10.5069 12.7247 10.1033 13.0128 9.7481 12.8367L6.56745 11.1723C6.42214 11.1083 6.26069 11.1083 6.11538 11.1723L2.93473 12.8367C2.57953 13.0128 2.1759 12.7247 2.24049 12.3406L2.85397 8.83568C2.87012 8.67564 2.8217 8.53159 2.72483 8.41956L0.141551 5.92292C-0.132921 5.65085 0.0123936 5.18673 0.399884 5.12271L3.96801 4.61062C4.11332 4.59461 4.24248 4.49858 4.32321 4.35454L5.90548 1.15372C6.08308 0.801626 6.58359 0.801626 6.76119 1.15372L8.34346 4.35454C8.42418 4.49858 8.55335 4.59461 8.69866 4.61062L12.2668 5.12271C12.6543 5.18673 12.7996 5.65085 12.5251 5.92292Z"
        fill="#FF6633"
      />
    </svg>
  );
}

export function StarFalse() {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1916 5.92292L10.6245 8.41956C10.5115 8.51559 10.463 8.67564 10.4953 8.83568L11.1088 12.3406C11.1734 12.7247 10.7698 13.0128 10.4146 12.8367L7.23395 11.1723C7.08864 11.1083 6.92719 11.1083 6.78188 11.1723L3.60123 12.8367C3.24603 13.0128 2.84241 12.7247 2.90699 12.3406L3.52047 8.83568C3.53662 8.67564 3.48821 8.53159 3.39133 8.41956L0.808055 5.92292C0.533583 5.65085 0.678898 5.18673 1.06639 5.12271L4.63451 4.61062C4.77982 4.59461 4.90899 4.49858 4.98971 4.35454L6.57198 1.15372C6.74958 0.801626 7.25009 0.801626 7.42769 1.15372L9.00996 4.35454C9.09069 4.49858 9.21985 4.59461 9.36516 4.61062L12.9333 5.12271C13.3208 5.18673 13.4661 5.65085 13.1916 5.92292Z"
        fill="#FF6633"
        fill-opacity="0.3"
      />
    </svg>
  );
}

export function Dropdown(props) {
  return (
    <div class="relative tablet:hidden">
      <div
        class="inline-flex h-full items-center overflow-hidden rounded-md"
        onClick={props.handleToggle}
      >
        <UserAvatar user="Tolulope" image="https://res.cloudinary.com/drlcisipo/image/upload/v1705704142/Website%20images/memoji_pkkvwn.png" size="lg" />
      </div>

      {props.hidden === false && (
        <div
          class="absolute end-0 z-10 mt-2 w-40 rounded-md border border-gray-100 bg-white shadow-lg"
          role="menu"
        >
          <div class="p-2 space-y-2 flex flex-col items-start">
            <a className="flex items-center gap-2 cursor-pointer">
              <div className="Settings w-9 h-9 bg-white rounded-[40px] shadow border border-indigo-300 flex items-center justify-center">
                <SettingIcon />
              </div>
              <span className="text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700">
                Settings
              </span>
            </a>
            <a className="flex items-center gap-2 cursor-pointer">
              <div className="Notification w-9 h-9 bg-white rounded-[40px] shadow border border-indigo-300 flex items-center justify-center">
                <NotificationIcon />
              </div>
              <span className="text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700">
                Notification
              </span>
            </a>
            <div className="TranslateWithIcon flex items-center ml-2 gap-4 cursor-pointer">
              <TranslateIcon />
              <span className="text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700">
                Translate
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export function NotificationSvg() {
  return (
    <span className="block">
      <svg className="w-6 h-6" width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.0149 18.1086C7.2674 18.1086 5.5199 17.8003 3.8624 17.1836C3.2324 16.9419 2.7524 16.4503 2.5424 15.8086C2.3249 15.1669 2.3999 14.4586 2.7449 13.8253L3.6074 12.2336C3.7874 11.9003 3.9524 11.2336 3.9524 10.8419L3.9524 8.43359C3.9524 5.33359 6.2249 2.80859 9.0149 2.80859C11.8049 2.80859 14.0774 5.33359 14.0774 8.43359V10.8419C14.0774 11.2253 14.2424 11.9003 14.4224 12.2419L15.2774 13.8253C15.5999 14.4253 15.6599 15.1503 15.4424 15.8086C15.2249 16.4669 14.7524 16.9669 14.1599 17.1836C12.5099 17.8003 10.7624 18.1086 9.0149 18.1086ZM9.0149 4.05859C6.8474 4.05859 5.0774 6.01693 5.0774 8.43359L5.0774 10.8419C5.0774 11.4503 4.8524 12.3503 4.5749 12.8753L3.7124 14.4669C3.5474 14.7753 3.5024 15.1003 3.5999 15.3753C3.6899 15.6586 3.9149 15.8753 4.2224 15.9919C7.3574 17.1586 10.6799 17.1586 13.8149 15.9919C14.0849 15.8919 14.2949 15.6669 14.3924 15.3669C14.4899 15.0669 14.4674 14.7419 14.3174 14.4669L13.4549 12.8753C13.1699 12.3336 12.9524 11.4419 12.9524 10.8336V8.43359C12.9524 6.01693 11.1899 4.05859 9.0149 4.05859Z" fill="#898989" />
        <path d="M10.4105 4.2834C10.358 4.2834 10.3055 4.27507 10.253 4.2584C10.0355 4.19173 9.82545 4.14173 9.62295 4.1084C8.98545 4.01673 8.37045 4.06673 7.79295 4.2584C7.58295 4.3334 7.35795 4.2584 7.21545 4.0834C7.07295 3.9084 7.02795 3.6584 7.11045 3.4334C7.41795 2.5584 8.16795 1.9834 9.02295 1.9834C9.87795 1.9834 10.628 2.55007 10.9355 3.4334C11.0105 3.6584 10.973 3.9084 10.8305 4.0834C10.718 4.21673 10.5605 4.2834 10.4105 4.2834Z" fill="#898989" />
        <path d="M9.01465 20.0088C8.27215 20.0088 7.55215 19.6755 7.02715 19.0921C6.50215 18.5088 6.20215 17.7088 6.20215 16.8838H7.32715C7.32715 17.3755 7.50715 17.8588 7.82215 18.2088C8.13715 18.5588 8.57215 18.7588 9.01465 18.7588C9.94465 18.7588 10.7021 17.9171 10.7021 16.8838H11.8271C11.8271 18.6088 10.5671 20.0088 9.01465 20.0088Z" fill="#898989" />
        <circle cx="13.9004" cy="5" r="4.48525" fill="#00B85E" stroke="white" stroke-width="0.970498" />
      </svg>

    </span>
  )
}

export function NoNotificationSvg() {
  return (
    <span className="block">
      <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.0149 18.1086C7.2674 18.1086 5.5199 17.8003 3.8624 17.1836C3.2324 16.9419 2.7524 16.4503 2.5424 15.8086C2.3249 15.1669 2.3999 14.4586 2.7449 13.8253L3.6074 12.2336C3.7874 11.9003 3.9524 11.2336 3.9524 10.8419L3.9524 8.43359C3.9524 5.33359 6.2249 2.80859 9.0149 2.80859C11.8049 2.80859 14.0774 5.33359 14.0774 8.43359V10.8419C14.0774 11.2253 14.2424 11.9003 14.4224 12.2419L15.2774 13.8253C15.5999 14.4253 15.6599 15.1503 15.4424 15.8086C15.2249 16.4669 14.7524 16.9669 14.1599 17.1836C12.5099 17.8003 10.7624 18.1086 9.0149 18.1086ZM9.0149 4.05859C6.8474 4.05859 5.0774 6.01693 5.0774 8.43359L5.0774 10.8419C5.0774 11.4503 4.8524 12.3503 4.5749 12.8753L3.7124 14.4669C3.5474 14.7753 3.5024 15.1003 3.5999 15.3753C3.6899 15.6586 3.9149 15.8753 4.2224 15.9919C7.3574 17.1586 10.6799 17.1586 13.8149 15.9919C14.0849 15.8919 14.2949 15.6669 14.3924 15.3669C14.4899 15.0669 14.4674 14.7419 14.3174 14.4669L13.4549 12.8753C13.1699 12.3336 12.9524 11.4419 12.9524 10.8336V8.43359C12.9524 6.01693 11.1899 4.05859 9.0149 4.05859Z" fill="#898989" />
        <path d="M10.4105 4.2834C10.358 4.2834 10.3055 4.27507 10.253 4.2584C10.0355 4.19173 9.82545 4.14173 9.62295 4.1084C8.98545 4.01673 8.37045 4.06673 7.79295 4.2584C7.58295 4.3334 7.35795 4.2584 7.21545 4.0834C7.07295 3.9084 7.02795 3.6584 7.11045 3.4334C7.41795 2.5584 8.16795 1.9834 9.02295 1.9834C9.87795 1.9834 10.628 2.55007 10.9355 3.4334C11.0105 3.6584 10.973 3.9084 10.8305 4.0834C10.718 4.21673 10.5605 4.2834 10.4105 4.2834Z" fill="#898989" />
        <path d="M9.01465 20.0088C8.27215 20.0088 7.55215 19.6755 7.02715 19.0921C6.50215 18.5088 6.20215 17.7088 6.20215 16.8838H7.32715C7.32715 17.3755 7.50715 17.8588 7.82215 18.2088C8.13715 18.5588 8.57215 18.7588 9.01465 18.7588C9.94465 18.7588 10.7021 17.9171 10.7021 16.8838H11.8271C11.8271 18.6088 10.5671 20.0088 9.01465 20.0088Z" fill="#898989" />
        <circle cx="13.9004" cy="5" r="4.48525" fill="#FF6633" stroke="white" stroke-width="0.970498" />
      </svg>

    </span>
  )
}
